<form nz-form [formGroup]="form" (ngSubmit)="onFormSubmit()">
	<app-text-field
		[label]="SECTION_CSV_LABELS[SectionCsvKeys.ssoSectionId]"
		[controlName]="SectionCsvKeys.ssoSectionId"
		[placeholder]="SECTION_CSV_LABELS[SectionCsvKeys.ssoSectionId]"
		[required]="form.get(SectionCsvKeys.ssoSectionId)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="SECTION_CSV_LABELS[SectionCsvKeys.ssoCourseId]"
		[controlName]="SectionCsvKeys.ssoCourseId"
		[placeholder]="SECTION_CSV_LABELS[SectionCsvKeys.ssoCourseId]"
		[required]="form.get(SectionCsvKeys.ssoCourseId)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="SECTION_CSV_LABELS[SectionCsvKeys.name]"
		[controlName]="SectionCsvKeys.name"
		[placeholder]="SECTION_CSV_LABELS[SectionCsvKeys.name]"
		[required]="form.get(SectionCsvKeys.name)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-language-dropdown-field
		[label]="SECTION_CSV_LABELS[SectionCsvKeys.language]"
		[controlName]="SectionCsvKeys.language"
		[placeholder]="SECTION_CSV_LABELS[SectionCsvKeys.language]"
		[required]="form.get(SectionCsvKeys.language)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-integer-field
		[label]="SECTION_CSV_LABELS[SectionCsvKeys.displayOrder]"
		[controlName]="SectionCsvKeys.displayOrder"
		[placeholder]="SECTION_CSV_LABELS[SectionCsvKeys.displayOrder]"
		[required]="form.get(SectionCsvKeys.displayOrder)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-date-picker-field
		[label]="SECTION_CSV_LABELS[SectionCsvKeys.activeStartDate]"
		[controlName]="SectionCsvKeys.activeStartDate"
		[placeholder]="SECTION_CSV_LABELS[SectionCsvKeys.activeStartDate]"
		[required]="form.get(SectionCsvKeys.activeStartDate)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-date-picker-field
		[label]="SECTION_CSV_LABELS[SectionCsvKeys.activeEndDate]"
		[controlName]="SectionCsvKeys.activeEndDate"
		[placeholder]="SECTION_CSV_LABELS[SectionCsvKeys.activeEndDate]"
		[required]="form.get(SectionCsvKeys.activeEndDate)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="SECTION_CSV_LABELS[SectionCsvKeys.sectionCode]"
		[controlName]="SectionCsvKeys.sectionCode"
		[placeholder]="SECTION_CSV_LABELS[SectionCsvKeys.sectionCode]"
		[required]="form.get(SectionCsvKeys.sectionCode)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-checkbox-field
		[label]="SECTION_CSV_LABELS[SectionCsvKeys.allowSelfRostering]"
		[controlName]="SectionCsvKeys.allowSelfRostering"
		[formGroup]="form"
	/>

	<app-checkbox-field
		[label]="SECTION_CSV_LABELS[SectionCsvKeys.active]"
		[controlName]="SectionCsvKeys.active"
		[formGroup]="form"
	/>

	<nz-form-item>
		<nz-form-control [nzOffset]="7" [nzSpan]="12">
			<div class="buttons">
				<button nz-button nzType="primary" [disabled]="loading() || form.invalid">
					Submit
					@if (loading()) {
						<nz-spin nzSimple nzSize="small"></nz-spin>
					}
				</button>
				<button nz-button (click)="onClearClicked()">Clear</button>
			</div>
		</nz-form-control>
	</nz-form-item>
</form>
